import { Action } from 'redux';
import { ContractConcept } from '../../../models/Entities/Contracts/ContractConcept';
import { ContractConceptState, ContractConceptUnloadState } from '../../states/ContractConceptState';


export default function ContractConceptUpdateReducer(
  state: ContractConceptState | undefined,
  action: Action
): ContractConceptState {
  const currentState = state ?? ContractConceptUnloadState;
  const a: any = action;
  let CurrentConcept: ContractConcept | undefined;

  switch (a.type) {
    case 'CONTRACTCONCEPT_RESET_SAVE_FLAGS_ACTION':
      return {
        ...currentState,
        isAddingNewOne: false, successAddingNewOne: undefined, failOnAddingNewOne: false,
        isUpdatingOne: false, successUpdatingOne: undefined, failOnUpdatingOne: false,
        error: undefined,
      };
    case 'CONTRACTCONCEPT_UPDATE_REQUEST_ACTION':
      return {
        ...currentState,
        isUpdatingOne: true,
        successUpdatingOne: undefined,
        failOnUpdatingOne: false,
      };
    
    case 'CONTRACTCONCEPT_UPDATE_RECEIVE_ACTION':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: true,
        failOnUpdatingOne: false,
      };
    
    case 'CONTRACTCONCEPT_UPDATE_FAIL_ACTION':
      return {
        ...currentState,
        isUpdatingOne: false,
        successUpdatingOne: false,
        failOnUpdatingOne: true,
        error: a.error,
      };
    
    default:
      return currentState;
  }
}
